import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { ParagonSecretStructure } from './types';

const VERSION = 'v2';

export const getParagonSecret = (accountId: string, projectId: string) => {
  return doGet<ParagonSecretStructure>(
    generateNextPath(ENDPOINTS.PARAGON, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    { version: VERSION },
  );
};

export const upsertParagonSecret = (
  accountId: string,
  projectId: string,
  secret: ParagonSecretStructure,
) => {
  return doPut<ParagonSecretStructure>(
    generateNextPath(ENDPOINTS.PARAGON, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    secret,
    { version: VERSION },
  );
};

export const deleteParagonSecret = (accountId: string, projectId: string) => {
  return doDelete<void>(
    generateNextPath(ENDPOINTS.PARAGON, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    undefined,
    { version: VERSION },
  );
};
